import appStore from 'store';
import api from './api';
import { PAGINATION } from 'common/config';
const store = {
  namespaced: true,
  state: {
    listData: [],
    listCount: 0,
    pairs: [],
    pagination: PAGINATION,
    pairBounsRecordInfo: {
      records: [],
      size: 10,
      total: 0
    },
    pairBounsRecordDetailInfo: {
      records: [],
      size: 10,
      total: 0
    },
    searchPairBounslInfo: {},
    publicUserInfo:{},
    pagination: {
      page: 1,
      size: 10
    }
  },
  mutations: {
    setList(state, payload) {
      state.listData = payload;
    },
    setListCount(state, payload) {
      state.listCount = payload;
    },

    setPairs(state, payload) {
      state.pairs = payload;
    },
    setPairBounsRecordInfo(state, payload) {
      state.pairBounsRecordInfo = payload;
    },
    setPairBounsRecordDetailInfo(state, payload) {
      state.pairBounsRecordDetailInfo = payload;
    },
    setPublicUserInfo(state, payload) {
      state.publicUserInfo = payload;
    },

    setSearchPairBouns(state, payload) {
      state.searchPairBounslInfo = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  getters: {},
  actions: {
    getList({ commit }, quary) {
      api.getList(quary).then(({ data }) => {
        commit('setList', data.list);
        commit('setListCount', data.totalCount);
        commit('setPagination', { page: quary.page, size: quary.size })
      });
    },
    getPairs({ commit }) {
      api.getPairs().then(({ data }) => {
        commit('setPairs', data);
      });
    },
    addPairBonus({ commit }, form) {
      return new Promise(resolve => {
        api.addPairBonus(form).then(res => {
          resolve(res);
        });
      });
    },

    //燃烧币种分红记录
    getPairBounsRecordList({ commit }, data) {
      api.getPairBounsRecordList(data).then(res => {
        commit('setPairBounsRecordInfo', res.data);
      });
    },
    //分红计算
    pairBounsCalculat({ commit }, form) {
      return new Promise(resolve => {
        api.pairBounsCalculat(form).then(res => {
          return resolve(res);
        });
      });
    },
    //燃烧币种分红记录详情
    getPairBounsRecordDetailList({ commit }, data) {
      api.getPairBounsRecordDetailList(data).then(res => {
        commit('setPairBounsRecordDetailInfo', res.data);
      });
    },
    //对公账户余额
    getPublicUserInfo({ commit }, data) {
      api.getPublicUserInfo(data).then(res => {
        commit('setPublicUserInfo', res.data);
      });
    },

    //分红记录相关数据
    getSearchPairBouns({ commit }, data) {
      return new Promise(resolve => {
        api.getSearchPairBouns(data).then(res => {
          commit('setSearchPairBouns', res.data);
          return resolve(res);
        });
      });
    },

    pairBounsAddOrUpdate({ commit }, data) {
      return new Promise(resolve => {
        api.pairBounsAddOrUpdate(data).then(res => {
          return resolve(res);
        });
      });
    },

    pairBounsGrant({ commit }, data) {
      return new Promise(resolve => {
        api.pairBounsGrant(data).then(res => {
          return resolve(res);
        });
      });
    }
  }
};

appStore.registerModule('burnCoinBonus', store);
